import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { bool, func, string } from "prop-types";
import React, { useCallback, useState } from "react";

import styled from "styled-components/macro";

import { faPlusCircle } from "@fortawesome/pro-solid-svg-icons";

import FnrSlides from "UI/FnrSlides";
import { colors } from "UI/colors";

import { WrapperVerticalPadding } from "../styles";

import MemoForm from "./MemoForm";

Memo.propTypes = {
  onRemoveMemo: func,
  onUpdateMemo: func,
  initialContent: string,
  hasHorizontalMargin: bool,
  disabled: bool,
};

const AddMemoButton = ({ toggleForm, disabled }) => {
  return (
    <ButtonWrapper>
      <Button onClick={toggleForm} disabled={disabled}>
        <FontAwesomeIcon icon={faPlusCircle} style={{ marginRight: "5px" }} />
        Add a Memo
      </Button>
    </ButtonWrapper>
  );
};

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const slidesConfig = [
  { key: "form", value: MemoForm },
  { key: "button", value: AddMemoButton },
];

export default function Memo({
  onRemoveMemo,
  onUpdateMemo,
  initialContent,
  disabled,
}) {
  const [isOpen, setIsOpen] = useState(Boolean(initialContent));

  const focusInput = useCallback(() => {
    if (!isOpen) return;

    let input = document.querySelector(".fundit-memo");
    input.focus();
  }, [isOpen]);

  const toggleForm = useCallback(() => {
    setIsOpen(!isOpen);
    focusInput();
  }, [focusInput, isOpen]);

  const removeMemo = useCallback(() => {
    onRemoveMemo();
    setIsOpen(false);
  }, [onRemoveMemo, setIsOpen]);

  return (
    <div>
      <Wrapper>
        <FnrSlides
          fullWidth
          activeKey={isOpen ? "form" : "button"}
          components={slidesConfig}
          toggleForm={toggleForm}
          placeholder="add memo here"
          onUpdate={onUpdateMemo}
          onRemove={removeMemo}
          initialContent={initialContent}
          disabled={disabled}
          variant="zoom"
          clip={false}
        />
      </Wrapper>

      <WrapperVerticalPadding />
    </div>
  );
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 0px min(28px, 8%);

  @media screen and (max-width: 420px) {
    margin-left: ${(props) =>
      !props.hasHorizontalMargin
        ? "auto"
        : props.isOpen
        ? "min(20px, 6%)"
        : "auto"};
    margin-right: ${(props) =>
      !props.hasHorizontalMargin
        ? "auto"
        : props.isOpen
        ? "min(20px, 6%)"
        : "auto"};
  }
`;

const Button = styled.button`
  width: 130px;
  border-radius: 50px;
  background-color: "hsl(0, 0%, 90%)";
  font-weight: 400;
  border: none;
  color: ${(p) => (p.disabled ? colors.fnGray : "#767676")};
  padding: 10px;
  cursor: ${(p) => (p.disabled ? "not-allowed" : "pointer")};
  font-weight: 400;
  transition: scale 0.25s ease-in-out;
  &:hover {
    ${(p) => !p.disabled && "scale: 1.05;"}
  }
`;
